/** Верхний отступ под чужой хром: вырез устройства плюс панель Telegram.
 *
 *  В полноэкранном режиме Telegram не отводит приложению место под свои
 *  «Закрыть» и «…», а кладёт их ПОВЕРХ страницы — вместе с часами и индикатором
 *  сети сверху. Отступ складывается из двух разных величин, и обе обязательны:
 *  `safeAreaInset` описывает устройство, `contentSafeAreaInset` — панель клиента.
 */
export type Inset = { top?: number } | undefined;

/** Сумма отступов, либо `null` — «клиент величин не знает».
 *
 *  Ноль и молчание — РАЗНЫЕ ответы, и путать их дорого. Ноль значит «отступ не
 *  нужен, контент уже под моей шапкой»: так открывается обычный, не
 *  полноэкранный режим. Отсутствие величин значит «клиент до Bot API 8.0», и
 *  тогда решение остаётся за CSS с его `env(safe-area-inset-top)`. Ноль,
 *  принятый за молчание, положил бы `env()` поверх шапки Telegram и дал вторую
 *  пустую полосу в высоту выреза.
 */
export function topInset(device: Inset, chrome: Inset): number | null {
  if (!device && !chrome) return null;
  return (device?.top ?? 0) + (chrome?.top ?? 0);
}
